import confetti from 'canvas-confetti';

// Examples taken from: https://www.kirilv.com/canvas-confetti/

export const showConfetti = (options: confetti.Options = {}) => {
    confetti({
        particleCount: 100,
        spread: 70,
        origin: options.origin || { y: 0.6 },
        zIndex: 5000,
    });
};
